import _computedMaxCroppingLeft from './computedMaxCroppingLeft'
import _computedMaxCroppingTop from './computedMaxCroppingTop'
import _computedMaxScaling from './computedMaxScaling'
import _computedMinCroppingLeft from './computedMinCroppingLeft'
import _computedMinCroppingTop from './computedMinCroppingTop'
import _computedMinScaling from './computedMinScaling'
import _croppingLeft from './croppingLeft'
import _croppingTop from './croppingTop'
import _relativeRotatedInternalImageHeight from './relativeRotatedInternalImageHeight'
import _relativeRotatedInternalImageWidth from './relativeRotatedInternalImageWidth'
import _rotatedInternalImageHeight from './rotatedInternalImageHeight'
import _rotatedInternalImageWidth from './rotatedInternalImageWidth'
import _scaledRotatedInternalImageHeight from './scaledRotatedInternalImageHeight'
import _scaledRotatedInternalImageHeightDifference from './scaledRotatedInternalImageHeightDifference'
import _scaledRotatedInternalImageWidth from './scaledRotatedInternalImageWidth'
import _scaledRotatedInternalImageWidthDifference from './scaledRotatedInternalImageWidthDifference'
import _scaling from './scaling'

export default {
  _imageWidth () {
    return this.$imageWidth * this.oversampling
  },
  _imageHeight () {
    return this.imageHeight * this.oversampling
  },
  _computedMaxCroppingLeft,
  _computedMaxCroppingTop,
  _computedMaxScaling,
  _computedMinCroppingLeft,
  _computedMinCroppingTop,
  _computedMinScaling,
  _croppingLeft,
  _croppingTop,
  _relativeRotatedInternalImageHeight,
  _relativeRotatedInternalImageWidth,
  _rotatedInternalImageHeight,
  _rotatedInternalImageWidth,
  _scaledRotatedInternalImageHeight,
  _scaledRotatedInternalImageHeightDifference,
  _scaledRotatedInternalImageWidth,
  _scaledRotatedInternalImageWidthDifference,
  _scaling
}
